const NDSApplier = (value: number | undefined = 0) => {
    if (value)
        return value + ((value / 100) * 22)
    else
        return 0
}
export default NDSApplier;